import { Mapper } from "../../../../base/utils/mapper";
import { BackgroundOptometryResponseModel } from "../../../../domain/models/consult/background-optometry-response.model";
import { BackgroundOptometryResponseEntity } from "../entities/background-optometry-response.entity";

export class BackgroundOptometryImplementationRepositoryMapper extends Mapper<BackgroundOptometryResponseEntity, BackgroundOptometryResponseModel> {
    mapFrom(param: BackgroundOptometryResponseEntity): BackgroundOptometryResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: BackgroundOptometryResponseModel): BackgroundOptometryResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}